export default __webpack_public_path__ + "8010f9be08ca2f55253297e95a72ef45.wasm";